import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPlaybookTemplateCard } from 'src/app/models/templates/playbooks/playbookTemplateCard.interface';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { PermissionsService } from 'src/app/services/infra/permissionsService/permissions.service';
import { PERMISSIONS } from 'src/app/models/permissions/permissions.const';

@Component({
  selector: 'app-playbook-template-card',
  templateUrl: './playbook-template-card.component.html',
  styleUrls: ['./playbook-template-card.component.scss'],
})
export class PlaybookTemplateCardComponent implements OnInit {
  @Input() public card: IPlaybookTemplateCard;
  @Output() public cardActionClick = new EventEmitter<string>();

  public hasPermisions: boolean;
  public tooltip: string;

  constructor(
    private readonly _permissionsService: PermissionsService,
    private readonly _labelProvider: LabelsProviderPipe
  ) {}

  ngOnInit(): void {
    this.hasPermisions = this._permissionsService.userHasPermission(PERMISSIONS.PLAYBOOK_OPERATION);
    this.tooltip = !this.hasPermisions ? this._labelProvider.transform('commonActions.operatorActionTooltip') : '';
  }

  public actionClicked(): void {
    this.cardActionClick.emit(this.card.actionData);
  }
}
